import React, { useEffect, useState } from "react";
import api from "../api/axios";

function ReportGroupSettings() {
  const [groups, setGroups] = useState([]);
  const [rootGroups, setRootGroups] = useState([]);
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [reportType, setReportType] = useState("BS");

  const token = localStorage.getItem("accessToken");
  const branch_id = sessionStorage.getItem("selectedContext")
    ? JSON.parse(sessionStorage.getItem("selectedContext")).branch
    : 0;

  /* ===============================
     Fetch settings
  =============================== */
  const fetchSettings = async () => {
    setLoading(true);
    try {
      const res = await api.get(
        `/report-settings/${reportType}?branch_id=${branch_id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setGroups(res.data.groups || []);
      setRootGroups(res.data.root_groups || []); // 🔑 IMPORTANT
      setSettings(res.data.settings || {});
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, [reportType]);

  /* ===============================
     Toggle (SUB GROUP ONLY)
  =============================== */
  const toggleGroup = (groupId) => {
    setSettings((prev) => ({
      ...prev,
      [groupId]: prev[groupId] === 0 ? 1 : 0,
    }));
  };

  /* ===============================
     Save
  =============================== */
  const saveSettings = async () => {
    try {
      await api.post(
        `/report-settings/${reportType}?branch_id=${branch_id}`,
        { groups: settings },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      alert("Settings saved successfully");
    } catch (err) {
      console.error(err);
      alert("Failed to save settings");
    }
  };

  /* ===============================
     Recursive Renderer
  =============================== */
  const renderGroupRow = (group, level = 1) => {
    // ✅ THE ONLY CORRECT MAIN GROUP CHECK
    const isMainGroup = rootGroups.includes(group.id);

    const isChecked = isMainGroup || settings[group.id] !== 0;

    return (
      <React.Fragment key={group.id}>
        <tr className={isMainGroup ? "table-secondary" : ""}>
          <td style={{ paddingLeft: `${level * 12}px` }}>
            {isMainGroup ? (
              <strong>{group.group_name}</strong>
            ) : (
              group.group_name
            )}
          </td>

          <td className="text-center">
            {isMainGroup ? (
              // 🔒 MAIN GROUP → NO CHECKBOX
              <span className="fw-bold text-success">✔</span>
            ) : (
              <input
                type="checkbox"
                checked={isChecked}
                onChange={() => toggleGroup(group.id)}
              />
            )}
          </td>
        </tr>

        {group.children?.map((child) =>
          renderGroupRow(child, level + 1)
        )}
      </React.Fragment>
    );
  };

  return (
    <>
      {/* Header */}
      <div className="row mb-3">
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h4 className="mb-0">
            {reportType} Group Configuration
          </h4>
          <button
            className="btn btn-success btn-sm"
            onClick={saveSettings}
          >
            Save
          </button>
        </div>
      </div>

      {/* Selector */}
      <div className="row mb-3">
        <div className="col-md-4">
          <select
            className="form-select"
            value={reportType}
            onChange={(e) => setReportType(e.target.value)}
          >
            <option value="BS">Balance Sheet</option>
            <option value="PL">Profit &amp; Loss</option>
            <option value="TB">Trial Balance</option>
          </select>
        </div>
      </div>

      {/* Table */}
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              {loading ? (
                <p>Loading...</p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-bordered align-middle ledger-table">
                    <thead>
                      <tr>
                        <th>Group</th>
                        <th className="text-center">Include</th>
                      </tr>
                    </thead>
                    <tbody>
                      {groups.length > 0 ? (
                        groups.map((group) =>
                          renderGroupRow(group)
                        )
                      ) : (
                        <tr>
                          <td colSpan="2" className="text-center">
                            No groups found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ReportGroupSettings;